<template>
	<footer id="footer" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 px-5 sm:px-10 bg-gray-700 text-white">
		<ul :class="['grid grid-rows-1 grid-cols-3 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 sm:col-span-12 md:col-span-12 gap-5 py-5']">
			<li v-for="(item, index) in socialMediaLinks" :key="index">
				<a class="flex flex-col items-center pb-2" :href="`${item.url}`" target="_blank">
					<v-icon large light class="lg:pb-2">{{ item.icon }}</v-icon>
					<span class="text-xs xl:text-base hover:underline">{{ item.title }}</span>
				</a>
			</li>
		</ul>
		<div class="rights py-5 sm:py-5 col-span-12 text-sm sm:text-xs md:text-sm lg:text-md flex-shrink-0 text-center">
			&copy; {{ year }} {{ company }}&nbsp;&#124;&nbsp;All rights reserved
		</div>
	</footer>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'Footer',
	created() {
		this.socialMedia().then(res => this.socialMediaLinks = res );
	},
	computed: {
	},
	components: {
	},
	data() {
		return {
			socialMediaLinks: '',
			year: new Date().getFullYear(),
			company: 'Milano Leather'
		}
	},
	methods: {
		...mapActions(['socialMedia']),
	},
}
</script>

<style lang="scss">
$bgc: #2e1511;
#footer {
	background-color: $bgc;
	.theme--light.v-icon {
		color: #fff;
	}
}
</style>
